(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('UzbCard', UzbCard);

    UzbCard.$inject = ['$resource'];

    function UzbCard ($resource) {
        var resourceUrl =  'api/uzb-cards/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
